// Module
var code = "<md-icon ng-class=\"vm.classes\">expand_more</md-icon> ";
// Exports
module.exports = code;